import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { FileText, Upload, Folder, File, Download, Trash2, Plus } from 'lucide-react';

export const DocumentsTab = ({ buildingId, t }) => {
  // This is a placeholder - documents functionality can be expanded later
  const [documents] = useState([]);

  return (
    <div className="space-y-4" data-testid="documents-tab">
      {/* Header */}
      <div className="flex items-center justify-between bg-slate-800/50 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Folder className="h-5 w-5 text-[#b4976f]" />
          <div>
            <span className="text-slate-300">Documenten</span>
            <p className="text-sm text-slate-500">{documents.length} bestanden</p>
          </div>
        </div>
        <Button 
          className="bg-[#b4976f] hover:bg-[#a3865f] text-white"
          data-testid="upload-document-btn"
          disabled
        >
          <Upload className="h-4 w-4 mr-2" />
          Document Uploaden
        </Button>
      </div>

      {/* Empty state */}
      <div className="text-center py-16 bg-slate-800/30 rounded-lg border border-dashed border-slate-700">
        <FileText className="h-16 w-16 mx-auto text-slate-600 mb-4" />
        <h3 className="text-lg font-medium text-white mb-2">Documentbeheer</h3>
        <p className="text-slate-400 max-w-md mx-auto mb-6">
          Upload en beheer relevante documenten voor dit gebouw, zoals taxatierapporten, 
          huurcontracten, energielabels, en technische rapporten.
        </p>
        <Badge variant="outline" className="border-amber-500 text-amber-400">
          Binnenkort beschikbaar
        </Badge>
      </div>

      {/* Document categories (future feature) */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 opacity-50">
        {[
          { name: 'Huurcontracten', icon: FileText, count: 0 },
          { name: 'Taxaties', icon: File, count: 0 },
          { name: 'Energielabels', icon: File, count: 0 },
          { name: 'Overig', icon: Folder, count: 0 }
        ].map((cat) => (
          <div key={cat.name} className="bg-slate-800/50 rounded-lg p-4 border border-slate-700">
            <cat.icon className="h-8 w-8 text-slate-500 mb-2" />
            <p className="text-white font-medium">{cat.name}</p>
            <p className="text-sm text-slate-500">{cat.count} bestanden</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsTab;
